// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c1971046","239":"2dd4b373","455":"d7320064"}[chunkId] + ".chunk.js";
};